var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLightroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 0.400002H5.66667C2.53333 0.400002 0 2.93334 0 6.06667V25.9333C0 29.0667 2.53333 31.6 5.66667 31.6H26.3333C29.4667 31.6 32 29.0667 32 25.9333V6.06667C32 2.93334 29.4667 0.400002 26.3333 0.400002ZM17.0133 22.252C17.0133 22.32 16.9747 22.372 16.9333 22.4133C16.8937 22.4401 16.8465 22.4537 16.7987 22.452H8.34667C8.2 22.452 8.13333 22.3707 8.13333 22.212V8.58667C8.12 8.49333 8.18667 8.41333 8.28 8.4H10.9467C11.0133 8.38667 11.0933 8.44 11.0933 8.50667V19.7467H17.2533C17.388 19.7467 17.428 19.812 17.4 19.9333L17.0133 22.252ZM25.3467 11.7733V14.3733C25.3467 14.48 25.28 14.52 25.1333 14.52C24.268 14.4667 23.4 14.6267 22.6133 14.9733C22.3467 15.0933 22.0933 15.2533 21.8933 15.4667V22.2667C21.8933 22.4 21.84 22.4533 21.72 22.4533H19.12C19.0133 22.4667 18.92 22.4 18.9067 22.2947V14.8533C18.9067 14.5333 18.9067 14.2 18.8933 13.8533C18.88 13.5067 18.88 13.16 18.8667 12.8133C18.8533 12.52 18.8267 12.2267 18.7853 11.9333C18.772 11.8667 18.812 11.8 18.8787 11.7867C18.892 11.7733 18.9053 11.7733 18.932 11.7867H21.2653C21.3987 11.7867 21.5053 11.88 21.5453 12C21.5987 12.0933 21.6387 12.2 21.652 12.3067C21.6787 12.44 21.704 12.5867 21.7187 12.72C21.732 12.8667 21.7467 13.0267 21.7467 13.2C22.1453 12.7333 22.6267 12.3467 23.172 12.0533C23.7853 11.72 24.4653 11.56 25.1587 11.5733C25.2507 11.56 25.332 11.6267 25.3453 11.72L25.3467 11.7733Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightroom);
export default __webpack_public_path__ + "static/media/icon_lightroom.06486920c3570cc43881336d59be1ba4.svg";
export { ForwardRef as ReactComponent };